import React from 'react';
import BookingForm from '../components/BookingForm/BookingForm';
import { useSearchParams, useLocation } from "react-router-dom";

const BookingFormPage = () => {
  const [searchParams] = useSearchParams();
    const location = useLocation();
  const { currentSelectedPlanType } = location.state || {};
  const subscription = searchParams.get("subscription");
  const plan = searchParams.get("plan");
  const treatment = searchParams.get("treatment");
  return (
    <div>
      <BookingForm subscription={subscription} plan={plan} treatment={treatment}/>
    </div>
  );
};

export default BookingFormPage;
